const COLORS = {
  bgDefault: '#EEF2F3',

  bgCall: '#1F3539',
  bgNameTag: '#1F3539'
}

export default COLORS
